import React, { useState, useEffect } from "react";
import { Card, Button, Form, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faTrash,
  faPen,
  faSave,
  faTimes,
  faBullhorn,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";

const Informaciones = () => {
  const [informaciones, setInformaciones] = useState([]);
  const [nuevaInfo, setNuevaInfo] = useState({ titulo: "", contenido: "" });
  const [editando, setEditando] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Cargar informaciones desde el backend
  const fetchInformaciones = async () => {
    try {
      const res = await axios.get("http://192.168.1.81:5000/backend/api/informaciones");
      setInformaciones(res.data);
    } catch (error) {
      console.error("Error cargando informaciones:", error);
    }
  };

  useEffect(() => {
    fetchInformaciones();
  }, []);

  // Manejar inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setNuevaInfo({ ...nuevaInfo, [name]: value });
  };

  // Agregar
  const handleAdd = async () => {
    if (!nuevaInfo.titulo || !nuevaInfo.contenido) return;
    try {
      const res = await axios.post("http://192.168.1.81:5000/backend/api/informaciones", nuevaInfo);
      setInformaciones([res.data, ...informaciones]);
      setNuevaInfo({ titulo: "", contenido: "" });
    } catch (error) {
      console.error("Error al guardar:", error);
    }
  };

  // Eliminar
  const handleDelete = async (id) => {
    try {
      await axios.delete(`http://192.168.1.81:5000/backend/api/informaciones/${id}`);
      setInformaciones(informaciones.filter((info) => info.id !== id));
    } catch (error) {
      console.error("Error al eliminar:", error);
    }
  };

  // Editar
  const handleSaveEdit = async () => {
    try {
      const res = await axios.put(
        `http://192.168.1.81:5000/backend/api/informaciones/${editando.id}`,
        editando
      );
      setInformaciones(
        informaciones.map((info) =>
          info.id === editando.id ? res.data : info
        )
      );
      setShowModal(false);
    } catch (error) {
      console.error("Error al actualizar:", error);
    }
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-3"><FontAwesomeIcon icon={faBullhorn} /> Informaciones</h2>

      {/* Formulario */}
      <Form className="mb-4">
        <Form.Group className="mb-2">
          <Form.Label>Título</Form.Label>
          <Form.Control
            type="text"
            name="titulo"
            value={nuevaInfo.titulo}
            onChange={handleChange}
            placeholder="Ej: Horarios de atención"
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label>Contenido</Form.Label>
          <Form.Control
            as="textarea"
            rows={2}
            name="contenido"
            value={nuevaInfo.contenido}
            onChange={handleChange}
            placeholder="Ej: Lunes a Viernes 9:00 - 18:00"
          />
        </Form.Group>
        <Button variant="primary" onClick={handleAdd}>
          <FontAwesomeIcon icon={faPlus} /> Agregar
        </Button>
      </Form>

      {/* Lista */}
      <div className="d-flex flex-wrap gap-3">
        {informaciones.map((info) => (
          <Card key={info.id} style={{ width: "18rem" }}>
            <Card.Body>
              <Card.Title>{info.titulo}</Card.Title>
              <Card.Text>{info.contenido}</Card.Text>
              <Button
                variant="warning"
                size="sm"
                className="me-2"
                onClick={() => { setEditando(info); setShowModal(true); }}
              >
                <FontAwesomeIcon icon={faPen} /> Editar
              </Button>
              <Button
                variant="danger"
                size="sm"
                onClick={() => handleDelete(info.id)}
              >
                <FontAwesomeIcon icon={faTrash} /> Eliminar
              </Button>
            </Card.Body>
          </Card>
        ))}
      </div>

      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title><FontAwesomeIcon icon={faPen} /> Editar Información</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-2">
              <Form.Label>Título</Form.Label>
              <Form.Control
                type="text"
                value={editando?.titulo || ""}
                onChange={(e) =>
                  setEditando({ ...editando, titulo: e.target.value })
                }
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Contenido</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={editando?.contenido || ""}
                onChange={(e) =>
                  setEditando({ ...editando, contenido: e.target.value })
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            <FontAwesomeIcon icon={faTimes} /> Cancelar
          </Button>
          <Button variant="success" onClick={handleSaveEdit}>
            <FontAwesomeIcon icon={faSave} /> Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Informaciones;
